import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector'; 

import translationEN from '../locales/en.json'; 
import translationFR from '../locales/fr.json'; 
import translationDE from '../locales/de.json'
import translationTR from '../locales/tr.json';
import translationES from '../locales/es.json';
import translationRU from '../locales/ru.json';
import translationZH from '../locales/zh.json';
import translationAR from '../locales/ar.json';
import translationHI from '../locales/hi.json';
import translationIT from '../locales/it.json';
import translationFA from '../locales/fa.json';

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
  de: {
    translation: translationDE,
  },
  tr: {
    translation: translationTR,
  },
  es: {
    translation: translationES,
  },
  ru: {
    translation: translationRU,
  },
  zh: {
    translation: translationZH,
  },
  ar: {
    translation: translationAR,
  },
  hi: {
    translation: translationHI,
  },
  it: {
    translation: translationIT,
  },
  fa: {
    translation: translationFA,
  },
};

i18n
  .use(LanguageDetector) 
  .use(initReactI18next) 
  .init({
    resources, 
    fallbackLng: 'en', 
    debug: true, 
    interpolation: {
      escapeValue: false, 
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie'],
    },
  });

export default i18n;
